export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5761.543c9f9a.jpg";